import { ItemEntryInput } from '@components/agile/types/ItemEntryTypes';
import { ASIN_REGEX } from '@constants/regexConstants';
import { ItemType } from '@graphql/generated/graphql';

const VALID_ITEM_TYPES = new Set(Object.values(ItemType).map((v) => v.toUpperCase()));

// Returns a specific error message for the first invalid entry, or null if all valid
export const getItemEntriesValidationError = (itemEntries: ItemEntryInput[]): string | null => {
  if (itemEntries.length === 0) {
    return 'CSV contains no data rows.';
  }

  for (let i = 0; i < itemEntries.length; i += 1) {
    const entry = itemEntries[i];
    const row = i + 2; // +2 because row 1 is the header, and arrays are 0-indexed
    if (!entry.itemId || entry.itemId.trim().length === 0) {
      return `Row ${row}: itemId is empty`;
    }
    if (!entry.itemType || entry.itemType.trim().length === 0) {
      return `Row ${row}: itemType is empty`;
    }
    if (!VALID_ITEM_TYPES.has(entry.itemType.trim().toUpperCase())) {
      return `Row ${row}: '${entry.itemType.trim()}' is not a valid item type. Must be one of: ${Array.from(VALID_ITEM_TYPES).join(', ')}`;
    }
    if (entry.itemType.trim().toUpperCase() === 'ASIN' && !ASIN_REGEX.test(entry.itemId.trim())) {
      return `Row ${row}: ASIN '${entry.itemId.trim()}' does not match expected format`;
    }
  }

  // Check all entries have the same itemType
  if (itemEntries.length > 1) {
    const itemTypes = new Set(itemEntries.map((e) => e.itemType.trim().toUpperCase()));
    if (itemTypes.size > 1) {
      return `All entries must have the same item type. Found: ${Array.from(itemTypes).join(', ')}`;
    }
  }

  return null;
};
